import React from 'react';
import SwivuHomeLogo from "./components/SwivuHomeLogo.jsx";
import SwivuHomeLogin from "./components/SwivuHomeLogin.jsx";
import SwivuHomeLayout from "./components/SwivuHomeLayout.jsx";


const SwivuLoginModal = ({ onLoginSuccess}) => {
  return (
    <SwivuHomeLayout>
      <SwivuHomeLogo />
      <>
        <h2 className="my-0 text-2xl  font-bold text-gray-900 dark:text-white font-['poppins'] mt-[24px]">
          Swivu HQ
        </h2>
        <ul className="space-y-1 list-inside dark:text-gray-200 px-0 flex flex-col items-center mt-3 mb-3 text-center max-w-[620px]">
        {[
          "Log in with Google to access your Swivu boards and take charge of your operations.",
          "Coordinate resources, delegate tasks, segment clients, and herd your cats—Swivu HQ \n gives you the control and clarity to keep everything moving."
          ].map((featureItem, idx) => (
          <li className="flex items-center text-base my-[0]" key={idx}>
            {featureItem}
          </li>
        ))}
        </ul>
        <SwivuHomeLogin onLoginSuccess={onLoginSuccess} />
      </>
    </SwivuHomeLayout>
  )
}

export default SwivuLoginModal;